import {
  jb_arrow_back_icon_css_default
} from "./chunk.ALSTFXWC.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-arrow-back-icon/jb-arrow-back-icon.ts
var JbArrowBackIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        width="9"
        height="15"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.985 7.725l6.358-6.358-.71-.71-7.071 7.07.71.711.003-.003L7.89 15.05l.71-.71-6.615-6.615z"
          fill-rule="evenodd"
        />
      </svg>
    `;
  }
};
JbArrowBackIcon.styles = [reset_css_default, jb_arrow_back_icon_css_default];
JbArrowBackIcon = __decorateClass([
  customElement("jb-arrow-back-icon")
], JbArrowBackIcon);

export {
  JbArrowBackIcon
};
